import { CTA } from "common/styleguide/CTA";
import { Modal } from "common/styleguide/Modal";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import { centeredText } from "lib/styleguide/base.scss";
import React from "react";
import styles from "./Modals.scss";

const SHORT_MODAL = "SHORT_MODAL";
const LONG_MODAL = "LONG_MODAL";

export class Modals extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
    };
  }

  componentDidMount = () => {
    const { location } = this.props;

    if (location && location.query && location.query.show === "long") {
      this.setState({ modal: LONG_MODAL });
    } else if (location && location.query && location.query.show === "short") {
      this.setState({ modal: SHORT_MODAL });
    }
  };

  componentDidMount = () => {
    const { location } = this.props;

    if (location && location.query && location.query.show === "long") {
      this.setState({ modal: LONG_MODAL });
    } else if (location && location.query && location.query.show === "short") {
      this.setState({ modal: SHORT_MODAL });
    }
  };

  showShortModal = () => {
    this.setState({ modal: SHORT_MODAL });
  };

  showLongModal = () => {
    this.setState({ modal: LONG_MODAL });
  };

  hideModal = () => {
    this.setState({ modal: null });
  };

  render() {
    const { modal } = this.state;
    return (
      <div className={styles.Modals}>
        <h1>Modals</h1>
        <p>Modal with header, content, and multiple CTAs</p>
        <div className={styles.modalContainer}>
          <Modal
            title="Log In"
            subtitle={
              <span>
                Subtitle content? <a>Subtitle content!</a>
              </span>
            }
          >
            <p>
              The Cat brings in a big red box from outside, from which he releases two identical creatures with blue
              hair and red suits called Thing One and Thing Two.
            </p>
            <CTA>Thing One</CTA>
            <CTA facebook>Thing Two</CTA>
            <div className={centeredText}>
              <a>Some other thing?</a>
            </div>
          </Modal>
        </div>
        <p>Modal with text content only and CTA</p>
        <div className={styles.modalContainer}>
          <Modal>
            <p>
              Voigt was born in Grevesmühlen, now in the state of Mecklenburg-Vorpommern, then in East Germany, about
              100 km north-east of Hamburg, in the same area as Tour de France winner Jan Ullrich.
            </p>
            <CTA>Shut Up Legs!</CTA>
          </Modal>
        </div>
        <p>Modal Overlay</p>
        <p>
          <CTA inline onClick={this.showShortModal}>
            Launch Modal Overlay
          </CTA>
          {modal === SHORT_MODAL && <ModalOverlayDemo onRequestClose={this.hideModal} />}
        </p>
        <p>Modal Overlay with scrolling content</p>
        <p>
          <CTA inline onClick={this.showLongModal}>
            Launch Long Modal Overlay
          </CTA>
          {modal === LONG_MODAL && <ModalOverlayDemoLong onRequestClose={this.hideModal} />}
        </p>
      </div>
    );
  }
}

const ModalOverlayDemo = ({ onRequestClose }) => (
  <ModalOverlay
    maxWidth={500}
    onRequestClose={onRequestClose}
    title="Modal Overlay"
    subtitle="this is a demo of the modal overlay"
  >
    <p>
      You 'mustn't' nothing in your life. I don't 'must' nothing in the life, just die. It's important, yeah, but I have
      also a future in front of me.
    </p>
    <p>- Peter Sagan</p>
    <CTA onClick={onRequestClose}>Close</CTA>
  </ModalOverlay>
);

const ModalOverlayDemoLong = ({ onRequestClose }) => (
  <ModalOverlay
    maxWidth={500}
    onRequestClose={onRequestClose}
    title="Long Modal Overlay"
    footer={<CTA onClick={onRequestClose}>Close</CTA>}
  >
    <p>
      Hodor, hodor; hodor hodor hodor hodor... Hodor hodor hodor?! Hodor! Hodor hodor, hodor - hodor; hodor hodor?
      Hodor, hodor - hodor, hodor, hodor hodor. Hodor! Hodor hodor, hodor - hodor; hodor hodor hodor. Hodor, hodor.
      Hodor. Hodor, hodor - hodor? Hodor, hodor. Hodor. Hodor, hodor hodor hodor; hodor HODOR hodor, hodor hodor.{" "}
    </p>
    <p>
      Hodor, hodor. Hodor. Hodor, hodor, hodor. Hodor hodor, hodor. Hodor hodor. Hodor, hodor. Hodor. Hodor, hodor -
      HODOR hodor, hodor HODOR hodor, hodor hodor. Hodor. Hodor hodor hodor. Hodor. Hodor. Hodor hodor; hodor hodor
      hodor! Hodor, HODOR hodor, hodor hodor... Hodor hodor hodor - hodor. Hodor. Hodor, hodor. Hodor. Hodor, hodor -
      hodor.{" "}
    </p>
    <p>
      Hodor, hodor. Hodor. Hodor, hodor hodor hodor?! Hodor, HODOR hodor, hodor hodor. Hodor. Hodor! Hodor hodor, hodor
      - hodor... Hodor hodor hodor hodor! Hodor, hodor hodor hodor hodor! Hodor hodor - hodor - hodor?{" "}
    </p>
    <p>
      Hodor! Hodor hodor, hodor hodor hodor... Hodor hodor hodor. Hodor. Hodor! Hodor hodor, hodor hodor hodor hodor,
      hodor, hodor hodor. Hodor, hodor. Hodor. Hodor, hodor hodor. Hodor hodor HODOR! Hodor HODOR hodor, hodor hodor
      hodor?! Hodor. Hodor hodor, hodor. Hodor hodor; hodor hodor, hodor, hodor hodor. Hodor, hodor... Hodor hodor hodor
      - hodor hodor! Hodor hodor hodor hodor. Hodor hodor HODOR! Hodor hodor - hodor hodor hodor hodor, hodor, hodor
      hodor.{" "}
    </p>
    <p>
      Hodor, hodor. Hodor. Hodor, hodor hodor hodor, hodor. Hodor hodor, hodor. Hodor hodor? Hodor hodor HODOR! Hodor
      HODOR hodor, hodor hodor hodor? Hodor. Hodor hodor, hodor. Hodor hodor; hodor hodor, hodor, hodor hodor. Hodor
      hodor, hodor. Hodor hodor - HODOR hodor, hodor hodor, hodor, hodor hodor. Hodor hodor; hodor hodor - hodor...
      Hodor hodor hodor hodor! Hodor hodor HODOR! Hodor hodor, hodor. Hodor hodor - HODOR hodor, hodor hodor hodor
      hodor, hodor, hodor hodor.{" "}
    </p>
    <p>
      Hodor, hodor; hodor hodor hodor hodor... Hodor hodor hodor?! Hodor! Hodor hodor, hodor - hodor; hodor hodor?
      Hodor, hodor - hodor, hodor, hodor hodor. Hodor! Hodor hodor, hodor - hodor; hodor hodor hodor. Hodor, hodor.
      Hodor. Hodor, hodor - hodor? Hodor, hodor. Hodor. Hodor, hodor hodor hodor; hodor HODOR hodor, hodor hodor.{" "}
    </p>
    <p>
      Hodor, hodor. Hodor. Hodor, hodor, hodor. Hodor hodor, hodor. Hodor hodor. Hodor, hodor. Hodor. Hodor, hodor -
      HODOR hodor, hodor HODOR hodor, hodor hodor. Hodor. Hodor hodor hodor. Hodor. Hodor. Hodor hodor; hodor hodor
      hodor! Hodor, HODOR hodor, hodor hodor... Hodor hodor hodor - hodor. Hodor. Hodor, hodor. Hodor. Hodor, hodor -
      hodor.{" "}
    </p>
    <p>
      Hodor, hodor. Hodor. Hodor, hodor hodor hodor?! Hodor, HODOR hodor, hodor hodor. Hodor. Hodor! Hodor hodor, hodor
      - hodor... Hodor hodor hodor hodor! Hodor, hodor hodor hodor hodor! Hodor hodor - hodor - hodor?{" "}
    </p>
    <p>
      Hodor! Hodor hodor, hodor hodor hodor... Hodor hodor hodor. Hodor. Hodor! Hodor hodor, hodor hodor hodor hodor,
      hodor, hodor hodor. Hodor, hodor. Hodor. Hodor, hodor hodor. Hodor hodor HODOR! Hodor HODOR hodor, hodor hodor
      hodor?! Hodor. Hodor hodor, hodor. Hodor hodor; hodor hodor, hodor, hodor hodor. Hodor, hodor... Hodor hodor hodor
      - hodor hodor! Hodor hodor hodor hodor. Hodor hodor HODOR! Hodor hodor - hodor hodor hodor hodor, hodor, hodor
      hodor.{" "}
    </p>
    <p>
      Hodor, hodor. Hodor. Hodor, hodor hodor hodor, hodor. Hodor hodor, hodor. Hodor hodor? Hodor hodor HODOR! Hodor
      HODOR hodor, hodor hodor hodor? Hodor. Hodor hodor, hodor. Hodor hodor; hodor hodor, hodor, hodor hodor. Hodor
      hodor, hodor. Hodor hodor - HODOR hodor, hodor hodor, hodor, hodor hodor. Hodor hodor; hodor hodor - hodor...
      Hodor hodor hodor hodor! Hodor hodor HODOR! Hodor hodor, hodor. Hodor hodor - HODOR hodor, hodor hodor hodor
      hodor, hodor, hodor hodor.{" "}
    </p>
  </ModalOverlay>
);
